import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import SellItemWizard from "components/sellItemWizard";
import ValidationNeeded from "components/item/validationNeeded";
import EstimationReady from "components/item/estimationReady";
import EstimationFailed from "components/item/estimationFailed";
import HighValueEstimationB from "components/item/highValue/highValueEstimationB";
import ShippingLabel from "components/item/shippingLabel";
import SupportNegotiation from "components/item/supportNegotiation";
import ShipBack from "components/item/shipBack";
import UploadPhoto from "components/imageUploader/UploadPhoto";
import { updateCustomExperiments } from "actions/experiments";
import { preShipmentUi } from "actions/personalize";
import { ado } from "actions/ado";
import WorthyApiErrors from "lib/api/worthyApiErrors";
import NoMatch from "components/noMatch";
import Login from "components/login";
import SurveyWrap from "components/surveyWrap";
import UserActions from "lib/userActions";
import I18n from "lib/i18n/i18n";

import {
    isDefaultPhone,
    p13nServiceDecisions,

    // Item states
    SUBMISSION,
    VALIDATION_NEEDED,
    ESTIMATION_READY,
    DELIVERED,
    SHIPPING,
    PENDING_AUCTION,
    PENDING_SALE,
    RETURN_PENDING,
    EVALUATION_READY,
    ON_HOLD,
    PRE_INVENTORY,
    INVENTORY,
    SALE_SCHEDULED,
    EVALUATION_BID,
    DONE,

    // Bundle state
    PICKUP_WAITING,
    ADDRESS_WAITING,
    IN_TRANSIT,
    JEWELRY_FOR_EXPERIMENTS,
    ESTIMATED,
    CLICKED_EDIT_PHOTOS,
    LS,
    rootUrl,
    isShipBack,
} from "helpers/ApplicationHelper";

import { siteItemPage } from "helpers/itemHelper";
import {
    acceptItemEstimation,
    clearItem,
    generateShippingLabel,
    getItem,
} from "actions/item";
import PendingAuction from "components/item/pendingAuction";
import PendingSale from "components/item/specialSaleFormats/pendingSale";
import SpecialProperties from "components/item/specialSaleFormats/specialProperties";
import UpdateReservePrice from "components/item/updateReservePrice";
import ScheduleSecureShipment from "components/item/scheduleSecureShipment";
import { browserHistory } from "react-router";
import WorthyApi from "lib/api/worthyApi";
import Trends from "./trends/trends";
import CoronaPage from "./coronaStaticPage";
import SurveyPopup from "./surveyPopup";
import PropTypes from "prop-types";
import Loader from "./loaderAnimated";

const TRENDS_FLOW_COMPLETE_KEY = "trends_flow_complete";

const BUNDLE_STATES_FOR_LISTING_PAGE = [
    ESTIMATED,
    ADDRESS_WAITING,
    PICKUP_WAITING,
];
const ITEM_STATES_FOR_GET_ESTIMATE_EXPERIMENT = [
    VALIDATION_NEEDED,
    ESTIMATION_READY,
];
const PRE_SHIPMENT_UI_STATES = [VALIDATION_NEEDED, ESTIMATION_READY, SHIPPING];

class Item extends Component {
    constructor(props) {
        super(props);
        const skipUploadPhoto =
            props.location.pathname.endsWith("skip_photo_upload");
        const newSubmissionFlow =
            props.location.pathname.endsWith("survey") || skipUploadPhoto;

        this.gettingItem = false;
        this.gettingP13n = false;
        this.state = {
            itemEstimationFailed: false,
            itemReloading: false,
            initialized: false,
            itemNotFound: false,
            itemWorkflowState: "",
            reAuth: null,
            analysis: null,
            reAnalyze: false,
            submittedPhoto: false,
            sendingHasAnotherItem: false,
            showSurvey: newSubmissionFlow,
            skipPhotoUpload: newSubmissionFlow && skipUploadPhoto,
        };

        // TODO: if the component is loaded without reloading the entire page, then it may be that the
        // TODO: get estimation request will never happen. This is because the item is returned from the
        // TODO: submit code and not from getItem. And getItem is where the estimation request happens...
        // TODO: if this is the case - force getting the item so that estimation will be called.
        if (this.props.ADO) {
            this.props.getItem(
                this.props.params.itemId,
                false,
                this.props.location.query
            );
            this.gettingItem = true;
        }
    }

    componentDidMount() {
        this.initCheck();
    }

    componentDidUpdate() {
        this.initCheck();
    }

    componentWillUnmount() {
        const itemInCache = this.props.item?.gettingItem;
        if (itemInCache === false) {
            //clear the Item state
            this.props.clearItem();
        }
    }

    static getDerivedStateFromProps(props, state) {
        // do we need to re-analyze item state?
        // AFTER getItem is fired => reAuth: false, itemReloading: false, reAnalyze: true
        console.log("Updating details");
        if (
            state.initialized &&
            !state.itemNotFound &&
            (state.reAnalyze ||
                state.itemWorkflowState !== props.item.workflow_state ||
                props.item.errors)
        ) {
            const analysis = Item.analyzeItemState(
                props.item,
                props.ADO,
                props.P13N,
                state,
                props.userFlow
            );

            return {
                itemWorkflowState: props.item.workflow_state,
                analysis,
            };
        }
        return null;
    }

    initCheck() {
        const { ADO, item, P13N } = this.props;
        if (!ADO || !ADO.user) {
            return;
        }

        console.info("Init item");
        // cannot continue without item
        if (!item) {
            return this.tryGetItem();
        }

        const needsPreShipmentUi = PRE_SHIPMENT_UI_STATES.includes(
            item.workflow_state
        );

        if (!P13N.preShipmentUi && needsPreShipmentUi) {
            this.tryGetP13n();
        }

        // TODO: rethink this when productizing
        this.logUserHasAnotherItem(ADO.user.id);
        const isLab = !item.estimation && item.desc?.includes("Lab Grown");

        // Only initialize when everything we need is ready.
        // For the initial states, we need to wait for estimation (required by EstimationReady component)
        if (
            !this.state.initialized &&
            item.workflow_state !== SUBMISSION &&
            (P13N.preShipmentUi || !needsPreShipmentUi) &&
            (item.estimation ||
                item.under_minimum_estimation ||
                item.item_type === "watch" ||
                !needsPreShipmentUi ||
                isLab)
        ) {
            this.initialize();
            this.setState({ initialized: true });
            console.info("Item initialized successfully");
        }
    }

    logUserHasAnotherItem(userId) {
        if (LS.get("hasAnotherItem") && !this.state.sendingHasAnotherItem) {
            this.setState({ sendingHasAnotherItem: true });
            WorthyApi.userHasAnotherItem(userId)
                .then(() => {
                    LS.removeItem("hasAnotherItem");
                })
                .catch((error) => {
                    this.setState({ sendingHasAnotherItem: false });
                    throw error;
                });
        }
    }

    tryGetItem = () => {
        if (this.props.ADO && !this.props.item && !this.gettingItem) {
            this.props.getItem(
                this.props.params.itemId,
                false,
                this.props.location.query
            );
            this.gettingItem = true;
        }
    };

    tryGetP13n = () => {
        // this.props.item.estimation &&
        let condition =
            this.props.item &&
            !this.props.P13N.preShipmentUi &&
            !this.gettingP13n;
        if (condition) {
            if (JEWELRY_FOR_EXPERIMENTS.includes(this.props.item.item_type)) {
                // Non rings and diamonds do not require estimation on Predictor side
                condition = this.props.item.value_category && condition;
            }
        }
        if (condition) {
            this.gettingP13n = true;
            this.props.preShipmentUi(this.props.item, this.props.ADO.user);
        }
    };

    // Got ADO and item. Now it's possible to analyze the global state and set easy to understand
    // component state and flags.
    initialize = () => {
        // Verify user is not missing details.
        // TODO: this should not be here. Instead, a user that is signed in should be checked
        // TODO: for all relevant requirements in a higher level component and redirected when something's
        // TODO: missing.
        if (this.props.ADO.user && isDefaultPhone(this.props.ADO.user.phone)) {
            console.log("Need more details");
            return browserHistory.push(
                "/item/" + this.props.params.itemId + "/missing-details/"
            );
        }

        // TODO: the value of props.item should not update for api error.
        // TODO: Research redux to see how to properly handle api errors without passing them
        // TODO: to the presentation layer.
        if (this.props.item instanceof WorthyApiErrors) {
            console.log("Get item API error:", this.props.item);

            // if item is not found set an easy state.
            if (this.props.item.hasError(404)) {
                this.setState({
                    reAuth: this.state.reAuth === null,
                    itemNotFound: true,
                    initialized: true,
                });
            }
            return;
        }

        if (
            !this.props?.item?.bundle?.converted_from_std_bundle &&
            this.props?.item?.restrict_jb_seller_enter_pending_auction
        ) {
            if (isShipBack(this.props?.item)) {
                return;
            }
            console.log("no able to see");
            window.location.href = window.location.origin + "/items";
        }
    };

    static userExperiments(experiments) {
        const experimentValue = (name) =>
            _.get(experiments, `${name}.variant`, false) === "true";

        return {
            highValueEstimation: experimentValue("high_value_estimation_exp"),
            getEstimate: experimentValue("get_estimate_exp"), // Set to 0 but active
        };
    }

    // All flags and functions called here use a 'positive' assumption - which
    // means that they will only check for the things required to render them.
    // they will not include disclaimers like 'if cui then not listing draft'.
    // The priority that derives from the 'disclaimers' will be set by asking
    // the questions in the right order in the itemRender() function or in the
    // checkRedirects() function.
    static analyzeItemState = (item, ADO, P13N, state, userFlow) => {
        const experiments = Item.userExperiments(ADO.experiments);

        // The auto re-estimate flag comes from a flow that can only happen when coming from a high value state.
        // In high value cui - we allow providing a GIA certificate number. In this case, it's possible that the
        // actual value of the jewel will be lower than our initial estimation, and then the user experience may
        // change suddenly to regular cui. We want to avoid that.
        const forceHighValue = item.auto_reestimate === true;

        const experimentsJewelry = JEWELRY_FOR_EXPERIMENTS.includes(
            item.item_type
        );

        const addressWaiting =
            item.workflow_state === SHIPPING &&
            item.bundle.workflow_state === ADDRESS_WAITING;

        const pickupWaiting =
            item.workflow_state === SHIPPING &&
            item.bundle.workflow_state === PICKUP_WAITING;

        const isSecondaryItem = !!item.main_item_id; // const from the monolith
        const secondaryItemsPreDeliveryStates =
            isSecondaryItem &&
            [
                // we should allow uploading for secondary items
                SUBMISSION,
                VALIDATION_NEEDED,
                SHIPPING,
            ].includes(item.workflow_state);

        const additionalItemWithoutPhotos =
            secondaryItemsPreDeliveryStates &&
            item.photos &&
            item.photos.length === 0;
        const preDeliveryStates =
            [VALIDATION_NEEDED, ESTIMATION_READY].includes(
                item.workflow_state
            ) || addressWaiting;

        const isHighValue = item.high_value_estimation || forceHighValue;

        // TODO: listing version may be 2.1.1 and it breaks JSON.parse(), so switching back to plain getItem()
        const listingVersion = window.localStorage.getItem(
            "LISTING_VERSION" + "-" + item.id
        );
        const openedListingScheduleModal = LS.get(
            "OPENED_SCHEDULE_MODAL" + "_" + item.id
        );

        const isHighValueCui =
            isHighValue &&
            preDeliveryStates &&
            experiments.highValueEstimation &&
            (!item.shipment || !item.shipment.active_pickup);

        const trends =
            experiments.getEstimate &&
            ITEM_STATES_FOR_GET_ESTIMATE_EXPERIMENT.includes(
                item.workflow_state
            ) &&
            experimentsJewelry &&
            !LS.get(TRENDS_FLOW_COMPLETE_KEY);

        const isWatch = item.item_type === "watch";

        const watchWithPhone =
            isWatch &&
            ADO.user &&
            ADO.user.phone &&
            item.workflow_state === ESTIMATION_READY;

        const rescheduleShipment =
            pickupWaiting &&
            item.reschedule_pickup_attempts < 3 &&
            !(item.shipment && item.shipment.active_pickup) &&
            !isSecondaryItem;

        const watchValidationNeeded =
            isWatch && item.workflow_state === SHIPPING;

        const estimationFailed =
            !!item.errors &&
            !item.estimation &&
            item.workflow_state === VALIDATION_NEEDED &&
            !isWatch;

        const uploadPhotoHV =
            isHighValueCui &&
            !item.has_submission_photo &&
            !state.submittedPhoto;

        const HV_listing =
            listingVersion &&
            P13N.preShipmentUi === p13nServiceDecisions.hybridHvCui;

        const uploadPhotoStandardCui =
            P13N.preShipmentUi === p13nServiceDecisions.hybridCui &&
            experimentsJewelry &&
            !state.submittedPhoto && // Todo: remove submittedPhoto once has_submission_photo updates on upload
            !item.has_submission_photo;

        const anyHybridCui = [
            p13nServiceDecisions.hybridHvCui,
            p13nServiceDecisions.hybridCui,
        ].includes(P13N.preShipmentUi);
        const anyListing =
            BUNDLE_STATES_FOR_LISTING_PAGE.includes(
                item.bundle && item.bundle.workflow_state
            ) &&
            ([
                p13nServiceDecisions.listingDraft,
                p13nServiceDecisions.lightListingDraft,
            ].includes(P13N.preShipmentUi) ||
                (P13N.preShipmentUi === p13nServiceDecisions.hybridHvCui &&
                    HV_listing) ||
                (anyHybridCui && openedListingScheduleModal));

        const hasPhoto = item.has_submission_photo && !!item.photos.length;

        const isListingUploadPhoto =
            !hasPhoto && !state.submittedPhoto && (anyListing || HV_listing);
        const isWatchPhotoUpload =
            !hasPhoto &&
            isWatch &&
            P13N.preShipmentUi === p13nServiceDecisions.lightListingDraft;

        const uploadPhoto =
            isListingUploadPhoto ||
            uploadPhotoStandardCui ||
            uploadPhotoHV ||
            additionalItemWithoutPhotos ||
            isWatchPhotoUpload;

        const standardOrHybridCui =
            [p13nServiceDecisions.cui, p13nServiceDecisions.hybridCui].includes(
                P13N.preShipmentUi
            ) ||
            (p13nServiceDecisions.default === P13N.preShipmentUi &&
                !isHighValue);

        const inExploreValueTrendsFlow =
            item.item_type === "ring" && userFlow === "explore_value_trends";

        const inExploreValueLightTrendsFlow =
            item.item_type === "ring" &&
            userFlow === "explore_value_light_trends";

        const inExploreValueRecentDealsFlow =
            item.item_type === "ring" &&
            userFlow === "explore_value_recent_deals";

        const pressedEditPhotos = LS.get(`${CLICKED_EDIT_PHOTOS}_${item.id}`);

        return {
            trends,
            preDeliveryStates,
            rescheduleShipment,
            watchWithPhone,
            watchValidationNeeded,
            addressWaiting,
            pickupWaiting,
            estimationFailed,
            experiments,
            isWatch,
            HV_listing,
            uploadPhoto,
            additionalItemWithoutPhotos,
            openedListingScheduleModal,
            standardOrHybridCui,
            anyListing,
            anyHybridCui,
            inExploreValueTrendsFlow,
            inExploreValueLightTrendsFlow,
            inExploreValueRecentDealsFlow,
            pressedEditPhotos,
        };
    };

    itemStateChanged = () => {
        this.props.getItem(this.props.item.id);
    };

    createShippingLabel = (params, refreshState = true) => {
        let shippingLabel = this.props.generateShippingLabel(
            this.props.item.id,
            params,
            refreshState
        );
        shippingLabel.then((res) => {});
        return shippingLabel;
    };

    acceptEstimation = (refreshState = true) => {
        return this.props.acceptItemEstimation(
            this.props.item.id,
            refreshState
        );
    };

    renderItem = () => {
        const { item, ADO } = this.props;
        const { analysis, skipPhotoUpload } = this.state;
        if (!item || !ADO) return null;
        let malcaSafeUser =
            ADO.corona_user_ids &&
            Array.isArray(ADO.corona_user_ids) &&
            ADO.corona_user_ids.includes(ADO.user.id);

        if (malcaSafeUser) {
            return <CoronaPage />;
        }

        if (
            item.under_minimum_estimation === true ||
            analysis.estimationFailed
        ) {
            return <EstimationFailed />;
        }

        if (analysis.preDeliveryStates) {
            if (analysis.inExploreValueTrendsFlow) {
                return this.listingTrends();
            }

            if (analysis.inExploreValueLightTrendsFlow) {
                return this.lightTrends();
            }

            if (analysis.inExploreValueRecentDealsFlow) {
                return this.exploreRecentDeals();
            }

            if (
                !skipPhotoUpload &&
                ((analysis.uploadPhotoHV && !this.state.submittedPhoto) ||
                    analysis.pressedEditPhotos)
            ) {
                return this.uploadPhoto();
            }

            if (analysis.trends) {
                return this.trends();
            }

            // should only get here when we need estimation and waiting for it to be ready.
            if (
                item.workflow_state === VALIDATION_NEEDED &&
                item.item_type !== "watch"
            ) {
                return this.validationNeeded();
            }

            if (
                item.workflow_state === ESTIMATION_READY &&
                item.item_type !== "watch"
            ) {
                if (analysis.watchWithPhone) {
                    return siteItemPage(item.id);
                }
            }

            if (
                !skipPhotoUpload &&
                analysis.uploadPhoto &&
                !this.state.submittedPhoto
            ) {
                return this.uploadPhoto();
            }

            return this.preShipmentUi();
        }

        if (analysis.watchValidationNeeded) {
            return this.validationNeeded();
        }

        if (
            !analysis.standardOrHybridCui &&
            (analysis.addressWaiting || analysis.rescheduleShipment)
        ) {
            this.preShipmentUi();
        }

        switch (item.workflow_state) {
            case SHIPPING:
                if (analysis.pickupWaiting) {
                    if (
                        analysis.anyListing ||
                        item.shipment.active_pickup === false
                    ) {
                        return this.preShipmentUi();
                    }
                    return this.scheduleSecureShipmentPlease(item);
                }
                return this.scheduleSecureShipmentPlease(
                    item,
                    item.bundle.workflow_state !== IN_TRANSIT
                );
            case DELIVERED:
                return this.scheduleSecureShipmentPlease(item, false);
            case PENDING_AUCTION:
                return (
                    <PendingAuction
                        item={item}
                        // item={{...item, scheduled_auction: true, scheduled_auction_upcoming_date: "2024-08-12T09:00:00.120Z", seller_notes: 'This is a very good item' }}
                        syaExp={true}
                        isNoGuaranteeNewDesignExp={true}
                    />
                );
            case PENDING_SALE:
                return <PendingSale item={item} format={item.format} />;
            case RETURN_PENDING:
                return item.enable_support_negotiation ? (
                    <SupportNegotiation item={item} />
                ) : (
                    <ShipBack item={item} />
                );
            case EVALUATION_READY:
            case ON_HOLD:
            case PRE_INVENTORY:
            case INVENTORY:
            case SALE_SCHEDULED:
                return item.format === "auction" &&
                    item.enable_support_negotiation ? (
                    <SupportNegotiation item={this.props.item} />
                ) : (
                    <SpecialProperties item={item} shipBack={false} />
                );
            case EVALUATION_BID:
                if (
                    item.advance_payment ||
                    item.reserve_price_met ||
                    item.price_guarantee
                )
                    return (window.location = siteItemPage(item.id)), null;
                return <UpdateReservePrice item={item} />;
            case DONE:
                return <SpecialProperties item={item} shipBack={false} />;
            default:
                if (__CLIENT__) window.location = siteItemPage(item.id);
        }
    };

    trends() {
        const flowComplete = () => {
            LS.set(TRENDS_FLOW_COMPLETE_KEY, "true");
            this.setState({ reAnalyze: true });
        };

        return <Trends params={this.props.params} onComplete={flowComplete} />;
    }

    handle404 = () => {
        if (this.props.Session && this.props.Session.isLoggedIn) {
            if (this.state.itemReloading) {
                return <div />;
            }

            return <NoMatch />;
        } else {
            // TODO: Login should move outside of the item page.
            // we should redirect to login and then return when successful.
            return this.loginForm();
        }
    };

    highValueCUI() {
        return (
            <HighValueEstimationB
                acceptEstimation={this.acceptEstimation}
                generateShippingLabel={this.createShippingLabel}
            />
        );
    }

    validationNeeded() {
        return (
            <ValidationNeeded
                item={this.props.item}
                onCompleteValidation={this.itemStateChanged}
            />
        );
    }

    standardCui = (rescheduleAttempts) => {
        return (
            <React.Fragment>
                {/* Step 3 of the SellItemWizard is the only relevant state for cui. other steps are earlier in the flow.*/}
                <SellItemWizard step={3} className={"item-container"} />
                <EstimationReady
                    item={this.props.item}
                    acceptEstimation={this.acceptEstimation}
                    generateShippingLabel={this.createShippingLabel}
                    reschedule_pickup_attempts={rescheduleAttempts}
                />
            </React.Fragment>
        );
    };

    loginForm() {
        return (
            <Login
                onSubmitForm={() => {
                    this.setState({ itemReloading: true });
                }}
                onLoginSuccessful={() => {
                    this.props.ado();
                    this.props
                        .getItem(
                            this.props.params.itemId,
                            false,
                            this.props.location.query
                        )
                        .then(() => {
                            this.setState({
                                itemNotFound: false,
                                reAuth: false,
                                itemReloading: false,
                                reAnalyze: true,
                            });
                        });
                }}
                showLinkToRegister={true}
            />
        );
    }

    renderSurvey() {
        const { item } = this.props;
        const { showSurvey, analysis } = this.state;

        if (
            item?.under_minimum_estimation === true ||
            analysis.estimationFailed
        )
            return "";

        if (showSurvey) {
            const ObjectId = item.id;
            const ObjectType = "Item";
            const isGemstone =
                item.properties?.plain_stone_type_name === "gemstone";

            // Note - update color and clarity properties of necklaces and earrings
            // of style 'minor stone' and watches, will cause an error on update properties
            const colorNClaritySurvey = ["ring", "loose diamond"];

            const surveyToShow = isGemstone
                ? "gemstoneColorNClarity"
                : colorNClaritySurvey.includes(item.item_type)
                ? "giaCertificateOrProperties"
                : "default";

            return (
                <SurveyWrap
                    ObjectId={ObjectId}
                    ObjectType={ObjectType}
                    surveyToShow={surveyToShow}
                    isGemstone={isGemstone}
                    title={I18n.getString(`survey::${surveyToShow}::title`)}
                    onSurveyClose={() => {
                        UserActions.survey(
                            "Survey modal closed",
                            ObjectId,
                            ObjectType,
                            "",
                            surveyToShow
                        );
                        this.setState({ showSurvey: false });
                        SurveyPopup.hide();
                    }}
                />
            );
        }

        return "";
    }

    render() {
        // Wait for initialization to finish.
        if (!this.props.Session) {
            return <Loader />;
        } else if (this.props.Session && !this.props.Session.isLoggedIn) {
            return this.loginForm();
        }

        if (!(this.props.Session && this.props.Session.isLoggedIn)) {
            if (this.state.itemNotFound) {
                return this.handle404();
            }
        }

        if (!this.state.initialized) {
            if (
                !this.props.item?.estimation &&
                this.props.item?.workflow_state === VALIDATION_NEEDED &&
                !this.state?.analysis?.isWatch
            ) {
                return <EstimationFailed />;
            } else {
                return <Loader />;
            }
        }

        // do we have an item?
        if (this.state.reAuth === true) {
            return this.loginForm();
        }

        if (this.state.itemNotFound) {
            return this.handle404();
        }
        return (
            <div id="item-container">
                {this.renderSurvey()}
                {this.renderItem()}
            </div>
        );
    }

    uploadPhoto = () => {
        const { item } = this.props;
        function removeStorageKey() {
            LS.remove(`${CLICKED_EDIT_PHOTOS}_${item.id}`);
            window.removeEventListener("popstate", removeStorageKey);
        }
        window.addEventListener("popstate", removeStorageKey);

        const onFinish = () => {
            LS.remove(`${CLICKED_EDIT_PHOTOS}_${item.id}`);
            this.setState({ submittedPhoto: true, reAnalyze: true });
        };
        return (
            <React.Fragment>
                <UploadPhoto Item={item} onFinish={onFinish} />
            </React.Fragment>
        );
    };

    listingDraft = () => {
        const { item } = this.props;
        return browserHistory.push(`/listing/${item.id}`);
    };

    listingDraftLight = () => {
        const { item } = this.props;
        return browserHistory.push(`/ll/${item.id}`);
    };

    listingTrends = () => {
        const { item } = this.props;
        return browserHistory.push(`/listing/${item.id}/trends`);
    };

    lightTrends = () => {
        const { item } = this.props;
        return browserHistory.push(`/item/${item.id}/lightTrends`);
    };

    exploreRecentDeals = () => {
        const { item } = this.props;
        window.location = rootUrl(
            `/about/recent-deals/rings/?item_id=${item.id}`
        );
    };

    scheduleSecureShipmentPlease = (item, editable = true) => {
        if (this.state.analysis.anyListing) {
            return this.preShipmentUi();
        }
        return <ScheduleSecureShipment item={item} editable={editable} />;
    };
    shippingLabel = (item) => <ShippingLabel item={item} />;

    preShipmentUi = () => {
        const { analysis, funnelStepEventFired } = this.state;
        const forceListingHvHybrid =
            analysis.openedListingScheduleModal || analysis.HV_listing;
        const preShipmentUi = this.props.P13N.preShipmentUi;
        const router = {
            [p13nServiceDecisions.cui]: this.standardCui,
            [p13nServiceDecisions.hvCui]: this.highValueCUI,
            [p13nServiceDecisions.hybridCui]:
                analysis.openedListingScheduleModal
                    ? this.listingDraft
                    : this.standardCui,
            [p13nServiceDecisions.hybridHvCui]: forceListingHvHybrid
                ? this.listingDraft
                : this.highValueCUI,
            [p13nServiceDecisions.listingDraft]: this.listingDraft,
            [p13nServiceDecisions.lightListingDraft]: this.listingDraftLight,
            [p13nServiceDecisions.default]: this.standardCui,
        };
        if (!funnelStepEventFired) {
            this.setState({ funnelStepEventFired: true });
        }
        return router[preShipmentUi]();
    };
}

Item.propTypes = {
    item: PropTypes.object,
    Session: PropTypes.object,
    params: PropTypes.object,
    ADO: PropTypes.object,
    P13N: PropTypes.object,
    location: PropTypes.object,
    generateShippingLabel: PropTypes.func,
    acceptItemEstimation: PropTypes.func,
    preShipmentUi: PropTypes.func,
    getItem: PropTypes.func,
    ado: PropTypes.func,
    clearItem: PropTypes.func,
    userFlow: PropTypes.string,
};

const mapStateToProps = ({
    ADO,
    ado,
    Session,
    Item,
    ShippingLabel,
    Experiments,
    Personalized,
    UserFlow,
}) => {
    return {
        ADO,
        ado,
        Session,
        item: Item,
        shippingLabel: ShippingLabel,
        exp: Experiments,
        P13N: Personalized,
        userFlow: UserFlow,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            ado,
            getItem,
            clearItem,
            generateShippingLabel,
            acceptItemEstimation,
            updateCustomExperiments,
            preShipmentUi,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Item);
